import type { MetaState } from '../state/MetaSlice';

import { useWallets } from '@rango-dev/widget-embedded';
import { useEffect, useRef } from 'react';

import { WalletTypes } from '../utils/Constants';

type ForceAutoConnectParams = {
  isActiveTab: boolean;
  loadingStatus: MetaState['loadingStatus'];
  walletType: string | null;
};

const SAFE_SUPPORTED_NAMESPACE = 'EVM';

export function useForceAutoConnect(params: ForceAutoConnectParams): void {
  const { isActiveTab, loadingStatus, walletType } = params;
  const { connect, state } = useWallets();
  const initiated = useRef(false);

  const wallet = Object.values(WalletTypes).find((w) => w.toLocaleLowerCase() === walletType);
  const walletState = wallet ? state(wallet) : null;

  useEffect(() => {
    const shouldTryConnect =
      isActiveTab &&
      loadingStatus === 'success' &&
      walletState &&
      walletType &&
      walletState.installed &&
      !walletState.connecting &&
      !walletState.connected;

    if (shouldTryConnect && !initiated.current) {
      initiated.current = true;
      connect(walletType, [{ namespace: SAFE_SUPPORTED_NAMESPACE, network: undefined }])
        .then()
        .catch((error: unknown) => {
          console.error(error);
        });
    }
  }, [walletState, isActiveTab, loadingStatus, walletType]);
}
